import { defaultRoutesOptions } from 'themes/default/variants/light/routes';

export const routesOptions = defaultRoutesOptions;
